import "./myPatients.scss";
import React from "react";
import { Box, Container } from "@mui/material";
import { PageLayoutDoctor } from "../../../components/page/page-layout-doctor";
import { useNavigate } from "react-router-dom";
import { PatientToolbar } from "../../../components/doctor/my-patients/patient-toolbar";
import { FormPatient } from "../../../components/doctor/my-patients/form-patient";

const EditPatient = () => {
  const navigate = useNavigate();

  const executeAction = (action) => {
    navigate("/my-patients");
  };

  return (
    <PageLayoutDoctor>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          <PatientToolbar handleClick={executeAction} label="Actualización de paciente" />
          <FormPatient action="update" />
        </Container>
      </Box>
    </PageLayoutDoctor>
  );
};

export default EditPatient;
